import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
    csvImportCount: any;    
}
const initialState: InitialState = {
    csvImportCount: [],    
};
const locationCsvUoloadRespoSlice = createSlice({
    name: "importcsvdata",
    initialState,
    reducers: {
        csvImportCount: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            csvImportCount: action.payload,
          }),
    }
})  

export const { csvImportCount } = locationCsvUoloadRespoSlice.actions;

export default locationCsvUoloadRespoSlice.reducer;